<template>
  <div class="transaction">
    <div class="date day">
      <b>{{ date.getDate() }}</b>
    </div>
    <div class="date month">
      {{ $t(`months.${date.getMonth()}`) }}
    </div>
    <div class="item">
      <b>{{ type }}{{ amount ? `: ${amount}` : '' }}</b>
    </div>
    <div class="place">{{ place }}</div>
    <div class="delta" :class="incoming ? 'incoming' : 'outgoing'">
      <RecyCoinIcon /> {{ delta }}
    </div>
  </div>
</template>

<i18n>
  {
    "es": {
      "type": {
        "NGO": "ONG",
        "DISCOUNT": "Descuento",
        "SHAMPOO": "Shampoo",
        "PLASTIC_BOTTLE": "Botella de Plástico"
      }
    },
    "en": {
      "type": {
        "NGO": "NGO",
        "DISCOUNT": "Discount",
        "SHAMPOO": "Shampoo",
        "PLASTIC_BOTTLE": "Plastic Bottle"
      }
    }
  }
</i18n>

<script>
  import { RecyCoinIcon } from '@/components/recyco';

  export default {
    name: 'transaction',
    components: {
      RecyCoinIcon,
    },
    props: {
      date: {
        type: Date,
        required: true,
      },
      amount: {
        type: Number,
      },
      type: {
        type: String,
        required: true,
      },
      delta: {
        type: Number,
        required: true,
      },
      place: {
        type: String,
        required: true,
      },
    },
    computed: {
      incoming() {
        return this.delta >= 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/mixins.scss';

  .transaction {
    background-color: var(--color-background);
    border-radius: 1em;
    @include drop-shadow();

    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      'day item delta'
      'month place delta';

    padding: 0.5em 1em;
    justify-items: start;
    align-items: center;
  }

  .date {
    place-self: stretch;
    border-right: solid var(--color-disabled) 1px;

    padding-right: 0.5em;
    text-align: center;
  }

  .day {
    grid-area: day;
  }

  .month {
    grid-area: month;
  }

  .item {
    grid-area: item;
    padding-left: 0.5em;
  }

  .place {
    grid-area: place;
    padding-left: 0.5em;
  }

  .delta {
    grid-area: delta;
    place-self: center;
  }

  .incoming {
    color: green;
  }

  .outgoing {
    color: red;
  }
</style>
